const TIME_OUT = 60 * 1000;

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export { BASE_URL, TIME_OUT };
